/**
 * @generated SignedSource<<f6b85eb6adc632ee428cd10e1325774d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentCompleted_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PaymentLinkCompleted_query">;
  readonly " $fragmentType": "PaymentCompleted_query";
};
export type PaymentCompleted_query$key = {
  readonly " $data"?: PaymentCompleted_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentCompleted_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentCompleted_query",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkCompleted_query"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "288aa8364b0d665825f2baca5a34ad07";

export default node;
